import React from 'react'
import { Trans } from '@lingui/react'
import styled from 'styled-components'

import Icon from '../../util/Icon'
import Title from '../../util/Title'
import AppContainer from '../../layout/AppContainer'
import PrimaryButton from '../../util/PrimaryButton'

const PageError = ({ error, ...props }) => (
    <AppContainer {...props}>
        <ContentContainer>
            <StyledIcon isLarge name="alarm" accentColor="primary" />
            <Title>
                <Trans id="Something went wrong!" />
            </Title>
            <ErrorMessage>
                <Trans id="It looks like we ran into a problem. Please try to reload this page or return to the homepage." />
            </ErrorMessage>
            <PrimaryButton
                onClick={() => {
                    window.location.href = '/'
                }}
            >
                <Trans id="Homepage" />
            </PrimaryButton>
        </ContentContainer>
    </AppContainer>
)

const ContentContainer = styled.main(
    ({ theme }) => `
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow: auto;
    padding: ${theme.spacingLarger}rem;
    background: ${theme.colorGreyWhite};
`,
)

const StyledIcon = styled(Icon)`
    margin-bottom: ${({ theme }) => theme.spacingSmaller}rem;
`

const ErrorMessage = styled.p`
    text-align: center;
`

export default PageError
